import { render } from "./BoardViewMenu.vue?vue&type=template&id=c11bf444"
import script from "./BoardViewMenu.vue?vue&type=script&lang=js"
export * from "./BoardViewMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__